import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function location() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage.location
  }
}
export function locationCode() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage.locationCode
  }
}
export function userName() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage.userName
  }
}
export function usermassage() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage
  }
}

export function locationCdeo() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage.locationCdeo
  }
}

// locationCdeo
export function userRole() {
  const token = Cookies.get(TokenKey)
  if (token) {
    const base64 = require('js-base64').Base64
    const massage = JSON.parse(base64.decode(token.split('.')[1]))
    return massage.userRole
  }
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
